<script>
	import CertificationsTypeList from '@components/certifications/CertificationTypeList.vue';
	import CertificationTypeEditor from '@components/certifications/CertificationTypeEditor.vue';
	import { mapActions, mapGetters } from 'vuex';

	export default {
		name: 'PageCertificationSettings',
		computed: {
			...mapGetters({
				certificationTypes: 'certificationTypes/getTypes'
			})
		},
		components: { CertificationsTypeList, CertificationTypeEditor },
		data() {
			return {
				isCertTypeEditorOpen: false,
				editingCertType: null
			};
		},
		methods: {
			...mapActions({
				initializeCertificationTypes: 'certificationTypes/initialize',
				initializeCertifications: 'certifications/initialize',
				upsertCertificationType: 'certificationTypes/upsert'
			}),
			handleAddCertType() {
				this.isCertTypeEditorOpen = true;
				this.editingCertType = null;
			},
			handleEditCertType(certType) {
				this.isCertTypeEditorOpen = true;
				this.editingCertType = certType;
			}
		},
		async created() {
			await this.$store.dispatch('setPageTitle', 'Certification Types');

			await Promise.all([this.initializeCertificationTypes(), this.initializeCertifications()]);
		}
	};
</script>

<template>
	<v-layout fill-height wrap>
		<v-flex md12 xl9 :class="$vuetify.breakpoint.name === 'xs' ? 'pr-0' : 'pr-2'">
			<CertificationsTypeList :certification-types="certificationTypes" @add="handleAddCertType" @edit="handleEditCertType" :enable-editing="true" />
		</v-flex>

		<CertificationTypeEditor :value="isCertTypeEditorOpen" :certification-type="editingCertType" @input="isCertTypeEditorOpen = $event" />
	</v-layout>
</template>

<style scoped></style>
